export default __webpack_public_path__ + "static/media/Everflow.b915e675.xlsx";